var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import fullPayment from "./fullPayment";
var fragment = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nfragment fullPaymentOrder on PaymentOrder {\n  uuid\n  userId\n  revisionId\n  amount\n  currency\n  countryCode\n  status\n  payments {\n    ...fullPayment\n  }\n}\n", "\n"], ["\nfragment fullPaymentOrder on PaymentOrder {\n  uuid\n  userId\n  revisionId\n  amount\n  currency\n  countryCode\n  status\n  payments {\n    ...fullPayment\n  }\n}\n", "\n"])), fullPayment);
export var toString = fragment.loc.source.body;
export default fragment;
var templateObject_1;
